import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';
import { NotificationService } from './services/notification.service';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { UppercaseInputDirective } from './directives/input-uppercase/uppercase-input.directive';
import { ContentLoadingComponent } from './components/content-loading/content-loading.component';
import { MultiselectAutocompleteComponent } from './components/multiselect-autcomplete/multiselect-autocomplete.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { ReusableGridTemplateComponent } from './components/reusable-grid-template/reusable-grid-template.component';
import { DirectiveModule } from './directives/directive.module';
import { ChatComponent } from './components/chat/chat.component';
import { StreamChatModule, StreamAutocompleteTextareaModule } from 'stream-chat-angular';
import { TranslateModule } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { UserAvatarComponent } from './components/user-avatar/user-avatar.component';
import { AgChartsAngularModule } from 'ag-charts-angular';
import { CustomHeaderComponent } from './components/custom-header/custom-header.component';
import { CustomRangePanelComponent } from './components/custom-header/custom-range-panel/custom-range-panel.component';
import { DateRangePickerService } from './components/custom-header/date-range-picker.service';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {
    RangeSelectionModule,
    ClipboardModule
  } from "ag-grid-enterprise";

@NgModule({
    declarations: [
        ContentLoadingComponent,
        MultiselectAutocompleteComponent,
        ReusableGridTemplateComponent,
        ChatComponent,
        UserAvatarComponent,
        CustomHeaderComponent,
        CustomRangePanelComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatAutocompleteModule,
        MatCheckboxModule,
        MatInputModule,
        MatFormFieldModule,
        MatInputModule,
        MatListModule,
        MatIconModule,
        FontAwesomeModule,
        MatDatepickerModule,
        DirectiveModule,
        TranslateModule.forRoot(), StreamAutocompleteTextareaModule, StreamChatModule
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AgGridModule,
        AgChartsAngularModule,
        ContentLoadingComponent,
        MultiselectAutocompleteComponent,
        ChatComponent,
        UserAvatarComponent,
        CustomHeaderComponent,
        CustomRangePanelComponent,
        DirectiveModule
        ],
    providers: [
        DateRangePickerService
    ]
})
export class SharedModule
{
}
